import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  height: 100%;

  min-height: 54px;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 10px;
`;

export const ViewContainer = styled.div.attrs({ className: "ql-editor" })`
  && {
    padding: 0;
  }

  && .ql-editor blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }
`;
